import { NewsFeed } from 'modules/news/desktop';
import { getServerSidePropsNewsListPage } from 'modules/news/utils';

export const getServerSideProps = getServerSidePropsNewsListPage;

export default NewsFeed;
